import { defineComponent as _defineComponent } from 'vue'
import SearchableTradeList from 'ah-trades/src/components/lists/SearchableTradeList.vue';
import CollateralInfoBlock from 'ah-trades/src/components/collaterals/CollateralInfoBlock.vue';
import TradeListFilters from 'ah-trades/src/components/lists/TradeListFilters.vue';
import { Subscription } from 'rxjs';
import {
  NotificationEventType,
  NotificationType,
  Client,
  clientTradeStates,
  clientTradeStatus,
  NotificationEvent,
  fxHedgingInstruments,
} from 'ah-api-gateways';
import OnBehalfOf from 'ah-common-lib/src/onBehalfOf/OnBehalfOf';
import { useWalletsStore } from '@/app/store/walletsModule';
import { useNotificationsStore } from 'ah-notifications/src/store';
import { computed, onBeforeMount, onUnmounted, ref, watch } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'AllTradesView',
  props: {
  clientId: { type: String, required: false },
  tradeId: { type: String, required: false },
},
  setup(__props) {

const props = __props;

const tradeEvents = [
  NotificationType.TRADE_CONFIRMED,
  NotificationType.TRADE_REJECTED,
  NotificationType.POSITION_STATUS_OPEN,
  NotificationType.POSITION_STATUS_CLOSE,
];

const services = getServices();

const requestManager = useRequestManager().manager;

const walletStore = useWalletsStore();

const notificationsStore = useNotificationsStore();

const router = useRouter();

const tradeList = ref<InstanceType<typeof SearchableTradeList>>();

const eventsSubscription = ref<Subscription>();

const client = ref<Client>();



onBeforeMount(() => {
  if (!props.clientId) {
    eventsSubscription.value = notificationsStore.notificationEvents.subscribe((event: NotificationEvent) => {
      if (
        event.eventType === NotificationEventType.NOTIFICATION_CREATED &&
        tradeEvents.includes(event.payload?.type!)
      ) {
        tradeList.value!.reload();
      }
    });
    walletStore.loadCollaterals({ force: true });
  }
});

const possibleTradeStates = computed(() => clientTradeStates);
const possibleTradeStatuses = computed(() => clientTradeStatus);
const possibleHedgingInstruments = computed(() => fxHedgingInstruments);

function getOnBehalfOfClient() {
  if (props.clientId) {
    requestManager
      .currentOrNew('getClient', services.client.getClient(props.clientId))
      .subscribe((response: Client) => {
        client.value = response;
      });
  }
}

watch(() => props.clientId, getOnBehalfOfClient, { immediate: true });

function goBack() {
  router.push('./');
}

onUnmounted(() => eventsSubscription.value?.unsubscribe());

return { __sfc: true,tradeEvents, services, requestManager, walletStore, notificationsStore, router, tradeList, eventsSubscription, client, props, possibleTradeStates, possibleTradeStatuses, possibleHedgingInstruments, getOnBehalfOfClient, goBack, SearchableTradeList, CollateralInfoBlock, TradeListFilters, OnBehalfOf }
}

})